<template>
  <div class="flex act-container">
    <div>
      <act-preview
        navigationBg="#F72727"
        phoneHeaderFixedColor="#fff"
        navigationTitle="组合套餐活动"
        phoneBodyOverflowHidden
      >
        <div slot="headerSlot">
          <div class="bg"></div>
        </div>
        <div class="slot">
          <div class="tabs flex">
            <div
              v-for="(v, i) in activitiesList"
              :key="i"
              class="tab"
              :class="{ active: i === 0 }"
            >
              {{ v.name }}
            </div>
          </div>
          <div
            class="header-img-wrapper "
            :class="{ 'prev-upload': type !== 'detail' }"
          >
            <el-upload
              class="upload flex flex-center"
              ref="upload"
              :disabled="type === 'detail'"
              :limit="1"
              :headers="{ 'X-Access-Token': $token }"
              :action="$uploadUrl"
              :onError="uploadError"
              :http-request="customUpload"
              :onProgress="uploading"
            >
              <div
                class="upload-img"
                v-if="ruleForm.gameBgp && type !== 'detail'"
              >
                <span class="hmicon icon-shangchuantupian1"></span>
              </div>
              <div
                class="empty"
                style="margin-top:60px; font-size: 12px"
                v-if="!ruleForm.gameBgp"
              >
                还没有主图立即
                <el-button type="primary" size="mini">添加</el-button>
              </div>
            </el-upload>
            <img
              class="header-img"
              v-if="ruleForm.gameBgp"
              :src="ruleForm.gameBgp"
              alt=""
            />
          </div>
          <div class="preview-container flex">
            <el-scrollbar :vertical="false" wrap-style="height: 360px;">
              <div class="act-info-wrapper ">
                <div
                  v-for="(v, i) in ruleForm.setRuleModelList"
                  :key="i"
                  class="second-tabs"
                >
                  <div
                    class="second-tab flex flex-center item-center"
                    @click="switchTab(v)"
                    :class="{ active: activeTab === v.areaName }"
                  >
                    <div style="line-height: 20px;">
                      <p class="area-name">{{ v.areaName }}</p>
                      <p class="area-num" v-if="v.areaNum">0/{{ v.areaNum }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </el-scrollbar>
            <el-scrollbar
              :vertical="false"
              wrap-style="height: 360px;background: #fff;"
              class="flex-1"
            >
              <div class="act-info-goods">
                <div
                  v-for="(v, i) in goodsRuleModelList"
                  :key="i"
                  class="flex mb20"
                >
                  <div style="width:50px" class="flex item-center flex-center">
                    <div class="radio"></div>
                  </div>
                  <el-image
                    style="width: 80px; height: 80px;border-radius:5px;"
                    :src="v.spuMainPic"
                    fit="fit"
                  ></el-image>
                  <div class="flex-1 flex flex-column  flex-between p10">
                    <div class="goods-name">
                      {{ v.wxshopSpuName }}
                    </div>
                    <div class="primary">
                      <span>¥</span> {{ v.wxshopPrice }}
                    </div>
                  </div>
                </div>
              </div>
            </el-scrollbar>
          </div>
          <div class="flex flex-between item-center bottom">
            <div class="cart">
              <img
                src="https://imgcdn.hemiao100.com/ThemePictures/%E7%BC%96%E7%BB%84%207%402x.png"
                alt=""
              />
            </div>
            <div class="submit ">
              提交订单
            </div>
          </div>
        </div>
      </act-preview>
    </div>
    <div class="add-goods-container">
      <div class="act-wrapper">
        <el-form
          ref="ruleForm"
          :rules="rules"
          :model="ruleForm"
          label-width="140px"
        >
          <div id="base">1.基本信息</div>
          <el-form-item label="活动标题" prop="gameName">
            <el-input
              @change="gameNameChange"
              size="small"
              v-model="ruleForm.gameName"
              placeholder="请输入活动名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="活动时间段选择" prop="activityDate">
            <el-date-picker
              :disabled="type === 'details'"
              :default-time="['00:00:00', '23:59:59']"
              v-model="ruleForm.activityDate"
              :picker-options="pickerOptions"
              type="datetimerange"
              align="right"
              start-placeholder="活动开始时间"
              end-placeholder="活动结束时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              size="small"
              class="mr10"
            ></el-date-picker >
            <!--div>
              开始时间：
              <el-date-picker
                      :disabled="type === 'details'"
                      v-model="ruleForm.activityDate[0]"
                      type="datetime"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      :default-time="['00:00:00', '23:59:59']"
                      placeholder="开始时间"
                      size="small"
                      class="mr10"
              >
              </el-date-picker>
            </div>
            <div>
              结束时间：
              <el-date-picker
                      size="small"
                      :editable="false"
                      v-model="ruleForm.activityDate[1]"
                      type="datetime"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      :default-time="'23:59:59'"
                      placeholder="结束时间"
                      :picker-options="pickerOptions"
              >
              </el-date-picker>
            </div-->
          </el-form-item>
          <el-form-item label="活动分享文案" prop="gameShareContent">
            <el-input
              :maxlength="30"
              style="width: 400px"
              size="small"
              clearable
              class="mr10 ipt"
              v-model.trim="ruleForm.gameShareContent"
              placeholder="请输入活动分享文案，30字以内"
            ></el-input>
          </el-form-item>
          <el-form-item label="活动主图" prop="gameBgp">
            <div v-if="ruleForm.gameBgp" class="flex">
              <div class="mr10 flex item-end priview">
                <el-image
                  class="img"
                  :src="ruleForm.gameBgp"
                  alt="logo"
                  :preview-src-list="[ruleForm.gameBgp]"
                />
                <div
                  class="opreat-wrapper flex item-center flex-center"
                >
                  <el-button type="text" @click="handleRemove('gameBgp')"
                    >删除</el-button
                  >
                </div>
              </div>
              <div class="el-upload__tip">
                <span class="mr">
                  上传图片注意：
                  <br />1.建议图片尺寸590*700 <br />2.图片格式：png、jpg、bmp
                </span>
              </div>
            </div>
            <el-upload
              v-else
              class="upload flex"
              ref="upload"
              :headers="{ 'X-Access-Token': $token }"
              :action="$uploadUrl"
              :onError="uploadError"
              :http-request="customUpload"
              :onProgress="uploading"
            >
              <div class="flex upload-upload-btn">
                <div class="btn flex flex-column flex-center open-file">
                  <div class="add-wrapper">
                    <span
                      class="hmicon icon-hao pointer"
                      style="margin-right: 0px"
                    ></span>
                  </div>
                  <span class="gray">上传主图</span>
                </div>
              </div>
              <div class="el-upload__tip" slot="tip">
                <span class="mr">
                  上传图片注意：
                  <br />1.建议图片尺寸为750x300像素的png图
                  <br />2.图片格式：只能上传jpg/png文件
                </span>
              </div>
            </el-upload>
          </el-form-item>
          <el-form-item label="活动规则说明" prop="gameRuleRemark">
            <hm-rich-editor
              v-model="ruleForm.gameRuleRemark"
              :html="ruleForm.gameRuleRemark"
            />
          </el-form-item>
          <div id="base">2.活动规则</div>
          <el-form-item label="搭配套餐组合价" prop="setPrice">
            <span v-if="type === 'details'" class="primary">{{
              ruleForm.setPrice
            }}</span>
            <el-input
              v-else
              maxlength="30"
              :disabled="type === 'details'"
              @mousewheel.prevent.native
              size="small"
              clearable
              class="mr10 ipt"
              @input="filterGt0OrFixed2('setPrice')"
              v-model.trim="ruleForm.setPrice"
              placeholder="请输入金额"
            ></el-input
            >元，选择商品
          </el-form-item>
          <el-form-item>
            <div
              v-for="(v, i) in ruleForm.setRuleModelList"
              :key="i"
              style="margin-bottom:40px"
            >
              <div class="flex item-center">
                区域{{ i + 1 }}可选
                <el-form-item
                  :prop="'setRuleModelList.' + i + '.areaNum'"
                  :rules="rules.areaNum"
                >
                  <span v-if="type === 'details'" class="primary">
                    {{ v.areaNum }}
                  </span>
                  <el-input
                    v-else
                    maxlength="30"
                    :disabled="type === 'details'"
                    @mousewheel.prevent.native
                    size="small"
                    clearable
                    style="width:100px"
                    class="mr10 ipt"
                    v-model.trim="v.areaNum"
                    @input="filterGt0OrFixed0('setRuleModelList', i, 'areaNum')"
                    placeholder="请输入数量"
                  ></el-input>
                </el-form-item>
                件
                <div v-if="type !== 'details'">
                  <div class="add-wrapper flex flex-center" v-if="i === 0">
                    <span
                      class="hmicon icon-hao pointer"
                      @click="addGood(i)"
                    ></span>
                  </div>
                  <div class="minus-wrapper flex flex-center" v-else>
                    <span
                      class="hmicon icon-jianhao pointer"
                      @click="deleteGood(i)"
                    ></span>
                  </div>
                </div>
              </div>
              <div class="flex item-center ">
                区域{{ i + 1 }}名称
                <el-form-item
                  :prop="'setRuleModelList.' + i + '.areaName'"
                  :rules="rules.areaName"
                >
                  <span v-if="type === 'details'" class="primary">
                    {{ v.areaName }}
                  </span>
                  <el-input
                    v-else
                    maxlength="30"
                    :disabled="type === 'details'"
                    @mousewheel.prevent.native
                    size="small"
                    style="width:300px"
                    clearable
                    class="mr10 ipt"
                    v-model.trim="v.areaName"
                    :placeholder="`请输入区域${i + 1}名称，建议不超过4个字`"
                  ></el-input>
                </el-form-item>
              </div>
              <div v-if="type !== 'details'">
                <el-button @click="addGoods(i)" type="primary" size="small"
                  >添加商品</el-button
                >
              </div>
              <div>
                <el-form-item
                  :prop="'setRuleModelList.' + i + '.setGoodsRuleModelList'"
                  :rules="rules.setGoodsRuleModelList"
                >
                  <el-table
                    :data="v.setGoodsRuleModelList"
                    style="width: 100%"
                    ref="table"
                    stripe
                    size="small"
                    max-height="300"
                  >
                    <el-table-column
                      header-align="center"
                      align="center"
                      type="index"
                      label="序号"
                    >
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      label="商品货号"
                      prop="goodsSn"
                    >
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      label="商品名称"
                      prop="wxshopSpuName"
                    >
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      label="规格"
                      prop="specIdGroupName"
                    >
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      label="活动库存"
                      prop="totalStockSum"
                    >
                      <template slot-scope="scope">
                        <el-form-item
                          :prop="
                            'setRuleModelList.' +
                              i +
                              '.setGoodsRuleModelList.' +
                              scope.$index +
                              '.totalStockSum'
                          "
                          :rules="rules.totalStockSum"
                          class="from-err"
                        >
                          <span v-if="type === 'details'">
                            {{ scope.row.totalStockSum }}
                          </span>
                          <el-input
                            v-else
                            size="small"
                            clearable
                            class="mr10 ml10 ipt"
                            maxlength="60"
                            style="width:150px"
                            @input="
                              filterGt0OrFixed0(
                                'setGoodsRuleModelList',
                                i,
                                'totalStockSum',
                                scope.$index
                              )
                            "
                            v-model.trim="scope.row.totalStockSum"
                            placeholder="请输入库存"
                          ></el-input>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      label="操作"
                      width="70px"
                      v-if="type !== 'details'"
                    >
                      <template slot-scope="scope">
                        <div class="minus-wrapper flex flex-center">
                          <span
                            class="hmicon icon-jianhao pointer"
                            @click="deleteGoodChild(i, scope.$index)"
                          ></span>
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-form-item>
              </div>
            </div>
          </el-form-item>
          <div id="base">3.活动限制</div>
          <el-form-item label="配送方式限制" prop="expressModeGroups">
            <el-checkbox-group v-model="ruleForm.expressModeGroups">

              <span class="title" style="display:flex;aligin-items:center; color:#666; font-size:14px; margin-right:16px;">
                选择门店：
                <div @click="outputExcelStores" class="delete pointer">
                  <span class="delete-icon hmicon icon-daochu"></span>
                  下载模板
                </div>
                <div class="delete mr20 pointer open-file" style="margin-left:20px;">
                  <span class="delete-icon hmicon icon-daoru"></span>
                  导入
                  <input
                      type="file"
                      @change="importfStore"
                      accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  />
                </div>
              </span>



              <div>
                <el-checkbox label="shop_extract">门店自提</el-checkbox>
                <el-select
                    class="ml10"
                    clearable
                    multiple
                    v-model="ruleForm.shopIds"
                    placeholder="请选择可销售门店"
                    size="small"
                    filterable
                    @change="getCheckedStore"
                    v-if="storeCode != '53010017032439' && storeCode != '42010216070190' "
                >
                  <el-option
                      label="全部门店"
                      value="all"
                      :disabled="selectOther"
                  ></el-option>
                  <el-option
                      :disabled="selectAll"
                      :label="v.shopName"
                      :value="v.shopId"
                      v-for="(v, i) in microShopStoreList"
                      :key="i"
                  ></el-option>
                </el-select>
                <el-select
                    class="ml10"
                    clearable
                    multiple
                    v-model="ruleForm.shopIds"
                    placeholder="请选择可销售门店"
                    size="small"
                    filterable
                    @change="getCheckedStore"
                    v-if="storeCode === '53010017032439' || storeCode === '42010216070190' "
                >
                  <el-option
                      label="全部门店"
                      value="all"
                      :disabled="selectOther"
                  ></el-option>
                  <el-option
                      :disabled="selectAll"
                      :label="v.shopName"
                      :value="v.shopId"
                      v-for="(v, i) in dkMicroShopStoreList"
                      :key="i"
                  ></el-option>
                </el-select>
              </div>
              <div>
                <el-checkbox label="express_delivery"
                >快递物流</el-checkbox
                >
                <el-select
                    size="small"
                    v-model="ruleForm.expressId"
                    filterable
                    class="ml10"
                    clearable
                    placeholder="请选择运费模板"
                >
                  <el-option
                      :label="v.expressName"
                      :value="v.expressId"
                      v-for="(v, i) in expressList"
                      :key="i"
                  ></el-option>
                </el-select>
              </div>
            </el-checkbox-group>
          </el-form-item>
          <!--<el-form-item label="配送方式限制" prop="expressModeGroups">
            <el-checkbox-group
              :disabled="type === 'details'"
              v-model="ruleForm.expressModeGroups"
            >
              <el-checkbox label="shop_extract">门店自提</el-checkbox>
              &lt;!&ndash; <el-checkbox label="local_delivery">送货上门</el-checkbox>
                  <el-checkbox label="meituan">美团配送</el-checkbox> &ndash;&gt;
              <el-checkbox label="express_delivery">快递物流</el-checkbox>
            </el-checkbox-group>
            <div
              class="form-item-tip"
              v-if="new Set(ruleForm.expressModeGroups).has('express_delivery')"
            >
              快递统一收费<el-input
                :disabled="type === 'details'"
                style="color:red"
                size="small"
                clearable
                @input="filterGt0OrFixed2('deliverMoney')"
                @mousewheel.prevent.native
                v-model="ruleForm.deliverMoney"
                placeholder="请输入运费"
              ></el-input
              >元（<strong>包邮默认显示0</strong>)
            </div>
          </el-form-item>-->
          <div class="flex flex-center">
            <el-button
              type="primary"
              size="small"
              @click="submitForm('ruleForm')"
              >发布</el-button
            >
            <el-button size="small" @click="$router.back(-1)">返回</el-button>
          </div>
        </el-form>
        <hm-filter-m-s-goods
          type="microShop"
          :visible="dialogVisible"
          :radio="isRadio"
          @saveGoods="saveGoods"
          @setLink="setLink"
          @close="dialogVisible = false"
        ></hm-filter-m-s-goods>
      </div>
    </div>
  </div>
</template>

<script>
import HmRichEditor from "@/components/HmRichEditor";
import HmFilterMSGoods from "@/components/HmFilterMSGoods";
import actPreview from "@/components/actPreview";
import { arrayUnique2, customImageUpload } from "@/utils/utils";
import {mapGetters} from "vuex";
import {getLoginUser} from "@/utils/auth";
let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串
export default {
  components: {
    actPreview,
    HmRichEditor,
    HmFilterMSGoods
  },
  data() {
    const expressModeGroupsStatus = (rule, val, callback) => {
      if (val.findIndex(v => v === "shop_extract") > -1) {
        if (!this.ruleForm.shopIds.length) {
          return callback(new Error("请选择可销售门店"));
        }
      }
      if (val.findIndex(v => v === "express_delivery") > -1) {
        if (!this.ruleForm.expressId) {
          return callback(new Error("请选择运费模板"));
        }
      }

      callback();
    };
    const patternSetPrice = (rule, val, callback) => {
      if (new Number(val) <= 0) {
        return callback(new Error("请输入大于0的金额"));
      }
      callback();
    };
    const patternList = (rule, val, callback) => {
      if (!val.length) {
        return callback(new Error("请添加商品"));
      } else {
        let flag = false;
        val.forEach(v => {
          if (!v.totalStockSum) {
            flag = true;
          }
        });
        if (flag) {
          return callback(new Error("有商品未填写库存"));
        }
      }
      callback();
    };
    return {
      storeCode: "",
      selectOther: false,
      selectAll: false,
      expressList: [],
      type: this.$route.query.type,
      gameId: this.$route.query.gameId,
      activeTab: "",
      activitiesList: [
        {
          name: "搭配套餐"
        },
        {
          name: "宝妈专享"
        },
        {
          name: "新客特惠"
        },
        {
          name: "大牌精选"
        }
      ],
      isRadio: false,
      dialogVisible: false,
      pickerOptions: {
        disabledDate(time) {
          let curDate = new Date().getTime();
          // 这里算出一个月的毫秒数,这里使用30的平均值,实际中应根据具体的每个月有多少天计算
          let day = 365 * 24 * 3600 * 1000;
          let dateRegion = curDate + day;
          return (
            time.getTime() < Date.now() - 8.64e7 || time.getTime() > dateRegion
          );
        }
      },
      showMyUpload: false,
      imgwidth: 0,
      imgheight: 0,
      ruleForm: {
        gameName: "搭配套餐",
        activityDate: "",
        gameShareContent: "",
        gameBgp: "https://imgcdn.hemiao100.com/ThemePictures/taocanghuodong.png",
        gameRuleRemark: "",
        setPrice: "",
        deliverMoney: 0,
        setRuleModelList: [
          {
            areaName: "",
            areaNum: "",
            setGoodsRuleModelList: []
          }
        ],
        expressModeGroups: [],
        expressId: ""
      },
      rules: {
        gameName: [
          {
            required: true,
            message: "请输入活动标题",
            trigger: "blur"
          },
          { min: 2, max: 30, message: "长度在 2 到 30 个字符", trigger: "blur" }
        ],
        activityDate: {
          required: true,
          message: "请输入活动时间",
          trigger: "blur"
        },

        gameShareContent: [
          {
            required: true,
            message: "请输入活动分享文案",
            trigger: "blur"
          }
        ],
        gameBgp: {
          required: true,
          message: "请上传图片",
          trigger: "blur"
        },
        gameRuleRemark: [
          {
            required: true,
            message: "请输入活动规则说明",
            trigger: "blur"
          }
        ],
        setPrice: [
          {
            required: true,
            message: "请输入金额"
          },
          {
            required: true,
            validator: patternSetPrice
          }
        ],
        setGoodsRuleModelList: [{ required: true, validator: patternList }],
        areaNum: [
          {
            required: true,
            message: "必填字段",
            trigger: "change"
          }
          // { required: true, validator: patternList }
        ],
        areaName: {
          required: true,
          message: "必填字段",
          trigger: "change"
        },
        totalStockSum: {
          required: true,
          message: "必填字段",
          trigger: "change"
        },
        winnerNum: [
          {
            required: true,
            message: "请输入中奖人数",
            trigger: "blur"
          },
          {
            required: true,
            pattern: /^[1-9]\d*$/,
            message: "请输入正整数",
            trigger: "blur"
          }
        ],
        isDefaultWinner: {
          required: true,
          message: "自主报名是否默认为中奖候选人",
          trigger: "blur"
        },
        /*expressModeGroups: {
          required: true,
          message: "请选择配送方式",
          trigger: "blur"
        }*/
        expressModeGroups: [
          {
            required: true,
            message: "请选择配送方式限制"
          },
          {
            required: true,
            validator: expressModeGroupsStatus
          }
        ]
      },
      index: 0,
      goodsRuleModelList: [],
      updateMode: ""
    };
  },
  computed: mapGetters(["storeStyle", "microShopStoreList", "dkMicroShopStoreList"]),
  created() {
    this.queryExpressList();
  },
  mounted() {
    const { storeCode } = getLoginUser();
    this.storeCode = storeCode;
    console.log("this.storeCode:",this.storeCode);
    if (storeCode === '42010216070190' || storeCode === '53010017032439') {
      this.$store.dispatch("queryDkMicroStoreList");
    } else {
      this.$store.dispatch("queryMicroStoreList");
    }
    if (this.type) {
      this.queryDetails();
    }
  },
  methods: {
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
      // 导出excel
    outputExcelStores() {
      console.log('导出excel')
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader = [
          "商店名称",
          "商店编码"
        ];
        const filterVal = [];
        const data = this.formatJson(filterVal, []);
        exportJsonToExcel(tHeader, data, "门店模板");
      });
    },
    // 导入excel
    importfStore(e) {
      console.log('导入excel')
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      reader.onload = async function(e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64"
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary"
          });
        }
        let result = null;
        wb.SheetNames.forEach(sheetName => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        const formatResult = [];
        let isRequired = true;
        result.forEach(v => {
          if (!v[0] || !v[1] ) {
            isRequired = false;
          } else {
            isRequired = true
          }
          formatResult.push({
            shopName:v[0],
            shopId:v[1]
          });
        });
        if (isRequired) {
          let arrs = []
          formatResult.forEach(v => {
            arrs.push({shopCode:v.shopId})
          });;
          const { result } = await that.$store.dispatch("importFilterShopCodeList", arrs);
          if(result && result.successShopInfoModelList){
            that.ruleForm.shopIds = result.successShopInfoModelList.map(e=>e.shopId);
          }
          // that.memberCount = formatResult.length;
        } else {
          if (!isRequired) {
            that.$message({
              message: "导入失败，请导入完整商店信息！",
              type: "warning"
            });
          }
        }
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },



    // 运费模板
    async queryExpressList() {
      const { result } = await this.$store.dispatch("storeExpressConfigList");
      this.expressList = [];
      if (result.defaultTemplate) {
        this.expressList.push(result.defaultTemplate);
      }
      this.expressList.push(...result.templateList);
    },
    getCheckedStore(storeList) {
      this.selectOther = storeList.findIndex(o => o !== "all") > -1;
      this.selectAll = storeList.findIndex(o => o === "all") > -1;
      if (this.selectAll) {
        this.ruleForm.shopIds = ["all"];
      }
    },
    gameNameChange(val) {
      this.activitiesList[0].name = val;
    },
    async queryDetails() {
      const { result } = await this.$store.dispatch("queryActivitDetail", {
        gameId: this.gameId
      });
      for (let key in this.ruleForm) {
        if (this.ruleForm.hasOwnProperty(key)) {
          this.ruleForm[key] = result[key];
        }
      }

      this.ruleForm.activityDate = [result.gameStartTime, result.gameEndTime];
      this.updateMode = result.updateMode;
    },
    filterGt0OrFixed2(prop) {
      //   if (prop === "commissionTerminal" || prop === "commissionSuperior") {
      //     this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      //   }
      this.ruleForm[prop] = this.ruleForm[prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.ruleForm[prop] = this.ruleForm[prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      if (this.ruleForm[prop].indexOf(".") < 0 && this.ruleForm[prop] != "") {
        //首位是0的话去掉
        this.ruleForm[prop] = parseFloat(this.ruleForm[prop]);
      }
    },
    filterGt0OrFixed0(list, index, prop, i) {
      if (list === "setRuleModelList") {
        this.ruleForm.setRuleModelList[index][
          prop
        ] = this.ruleForm.setRuleModelList[index][prop].replace(/^(0+)/, ""); //过滤0开头
        this.ruleForm.setRuleModelList[index][
          prop
        ] = this.ruleForm.setRuleModelList[index][prop].replace(
          /^(0+)|[^\d]+/g,
          ""
        );
        this.ruleForm.setRuleModelList[index][
          prop
        ] = this.ruleForm.setRuleModelList[index][prop].replace(/\.{2,}/g, ""); //两个连续的"."仅保留第一个"."
      } else {
        this.ruleForm.setRuleModelList[index].setGoodsRuleModelList[i][
          prop
        ] = this.ruleForm.setRuleModelList[index].setGoodsRuleModelList[i][
          prop
        ].replace(/^(0+)/, ""); //过滤0开头
        this.ruleForm.setRuleModelList[index].setGoodsRuleModelList[i][
          prop
        ] = this.ruleForm.setRuleModelList[index].setGoodsRuleModelList[i][
          prop
        ].replace(/^(0+)|[^\d]+/g, "");
        this.ruleForm.setRuleModelList[index].setGoodsRuleModelList[i][
          prop
        ] = this.ruleForm.setRuleModelList[index].setGoodsRuleModelList[i][
          prop
        ].replace(/\.{2,}/g, ""); //两个连续的"."仅保留第一个"."
      }
    },
    switchTab(item) {
      this.activeTab = item.areaName;
      this.goodsRuleModelList = item.setGoodsRuleModelList;
    },
    addGoods(i) {
      this.index = i;
      this.dialogVisible = true;
    },
    saveGoods(data) {
      if (data.length) {
        data.map(v => {
          this.ruleForm.setRuleModelList[this.index].setGoodsRuleModelList.push(
            {
              wxshopSpuName: v.wxshopSpuName,
              goodsSn: v.goodsSn,
              specIdGroupName: v.specIdGroupName,
              wxshopSkuId: v.wxshopSkuId,
              wxshopPrice: v.wxshopPrice,
              spuMainPic: v.spuMainPic,
              totalStockSum: v.stockNum ? "" : ""
            }
          );
        });
        this.ruleForm.setRuleModelList[
          this.index
        ].setGoodsRuleModelList = arrayUnique2(
          this.ruleForm.setRuleModelList[this.index].setGoodsRuleModelList,
          "wxshopSkuId"
        );

        this.dialogVisible = false;
      } else {
        this.$message({
          message: "请选择商品",
          type: "warning"
        });
      }
    },
    setLink(row) {
      this.dialogVisible = false;
      this.isRadio = false;
    },
    addGood() {
      this.ruleForm.setRuleModelList.push({
        areaNum: "",
        areaName: "",
        setGoodsRuleModelList: []
      });
    },
    deleteGoodChild(i, index) {
      this.ruleForm.setRuleModelList[i].setGoodsRuleModelList.splice(index, 1);
    },
    deleteGood(i) {
      this.ruleForm.setRuleModelList.splice(i, 1);
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.ruleForm));
          params.gameStartTime =
            this.ruleForm.activityDate && this.ruleForm.activityDate.length > 0
              ? this.ruleForm.activityDate[0]
              : "";
          params.gameEndTime =
            this.ruleForm.activityDate && this.ruleForm.activityDate.length > 0
              ? this.ruleForm.activityDate[1]
              : "";
          params.gameType = "combination_set";
          let name = this.type == "details" ? "editActivity" : "addTurntable";
          params.gameId = this.gameId;
          params.updateMode = this.updateMode;
          if(this.type == "detail"){
            params.isLook = 'yes';
          }
          if (this.type === "edit") {
            this.$store.dispatch("editGameInfoJieLong", params).then(res => {
              if (res.code === "0") {
                this.$message({
                  message: "操作成功",
                  type: "success"
                });
                this.$router.back(-1);
              }
            });
          } else {
            this.$store.dispatch(name, params).then(res => {
              if (res.code === "0") {
                this.$message({
                  message: "操作成功",
                  type: "success"
                });
                this.$router.back(-1);
              }
            });
          }

        } else {
          return false;
        }
      });
    },
    // 移除上传文件
    handleRemove(spreadBgp) {
      this.ruleForm[spreadBgp] = "";
    },
    cropUploadSuccess(jsonData) {
      if (jsonData.code === 0) {
        this.ruleForm.gameBgp = jsonData.result;
        // setTimeout(() => {
        //   this.show = false;
        // }, 0);
      }
    },
    // 正在上传
    uploading() {
      //   this.isSaving = true;
    },
    // 上传错误
    uploadError() {
      this.$message({
        message: "上传失败，请重试!",
        type: "warning"
      });
      //   this.isSaving = false;
    },
    // 上传前对文件的大小的判断
    beforeAvatarUpload(file) {
      const extension =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "jpg";
      const extension2 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
        "jpeg";
      const extension3 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "png";
      const extension4 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "bmp";
      // file.size单位为b，除以1024得到kb
      // const limitSize = file.size / 1024 <= 100;
      if (!extension && !extension2 && !extension3 && !extension4) {
        this.$message({
          message: "上传模板只能是 jpg、jpeg、png、bmp格式!",
          type: "warning"
        });
      }
      // if (!limitSize) {
      //   this.$message({
      //     message: "上传模板大小不能超过 100k!",
      //     type: "warning"
      //   });
      // }
      return extension || extension2 || extension3 || extension4;
    },
     async customUpload(options) {
       return customImageUpload({
        ...options,
        fileDir: 'mall',
        token: this.$token,
        onSuccess: (result) => {
          this.cropUploadSuccess(result);
          options.onSuccess(result);
        },
        onError: (error) => {
          this.$message({
            message: "图片上传失败，请重新选择图片!",
            type: "warning"
          });
          options.onError(error);
        }
      });
  },
  }
};
</script>
<style lang="scss">
.from-err {
  .el-form-item__error {
    top: 12px;
    left: 112px;
  }
}
</style>
<style scoped lang="scss">
.act-container {
  max-width: 2000px;
  overflow-x: auto;
  .preview-container {
    .act-info-wrapper {
      margin-bottom: 20px;
    }
    .act-info-goods {
      // background: #fff;
      padding: 10px 0;
      height: 360px;
      font-size: 13px;
      .radio {
        width: 20px;
        height: 20px;
        border: 1px solid #cccccc;
        border-radius: 50%;
      }
      .goods-name {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
    }
    .second-tabs {
      background: #f5f5f5;
      .second-tab {
        width: 80px;
        height: 60px;
        &.active {
          background: #fff;
          color: #f72b2b;
          border: none;
          position: relative;
          font-weight: 600;
          .area-num {
            color: #999;
          }
        }
        .area-name {
          text-align: center;
          font-size: 15px;
        }
        .area-num {
          text-align: center;
          font-size: 12px;
        }
      }
    }
  }
  .upload-upload-btn {
    .tips {
      color: #999;
      font-size: 12px;
      line-height: 20px;
    }

    .btn {
      border: 1px solid #ddd;
      text-align: center;
      margin-left: 0;
      // padding: 10px;
      margin-right: 10px;
      width: 400px;
      height: 150px;
      cursor: pointer;
      .add-wrapper {
        width: 30px;
        height: 30px;
        line-height: 30px;
        background: #e50065;
        color: #fff;
        text-align: center;
        border-radius: 50%;
        margin: 0 auto;
        span {
          font-size: 12px;
        }
        cursor: pointer;
        .hmicon {
          font-size: 14px;
        }
      }
    }
  }

  .priview {
    position: relative;
    width: 400px;
    height: 150px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    margin: 10px;
    .img {
      width: 100%;
      height: 100%;
    }
    img {
      width: 100%;
      height: 100%;
    }
    .opreat-wrapper {
      transition: opacity 0.2s linear;
      position: absolute;
      opacity: 0;
      top: 0;
      left: 0;
      right: 0;
      // bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      border-radius: 6px;
    }

    &:hover {
      .opreat-wrapper {
        opacity: 1;
      }
    }
  }

  .add-goods-container {
    width: 1128px;
    flex-shrink: 0;
  }
  .slot {
    position: relative;
    background-size: 100% 100%;
    height: 100%;
    &:hover {
      .change-bg {
        display: block;
      }
    }
    .header-img-wrapper {
      box-sizing: border-box;
      height: 150px;
      .header-img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }
    .bottom {
      background: #fff;
      padding: 5px 10px;
      .cart {
        margin-top: -30px;
        z-index: 111;
        background: #fff;
        padding: 15px 5px;
        border-radius: 50%;
        img {
          width: 50px;
          height: 37px;
        }
      }
      .submit {
        width: 110px;
        height: 30px;
        line-height: 30px;
        background: #999999;
        border-radius: 38px;
        text-align: center;
        opacity: 0.5;
        color: #fff;
      }
    }

    .tabs {
      background: #fff;

      .tab {
        color: #000;
        box-sizing: border-box;
        height: 34px;
        line-height: 34px;
        width: 174px;
        text-align: center;

        &.active {
          background: #fff;
          color: #f72b2b;
          border: none;
          position: relative;
          font-weight: 600;
          &::after {
            position: absolute;
            bottom: 0;
            left: 50%;
            content: "";
            width: 50px;
            height: 3px;
            transform: translateX(-50%);
            background: #f72b2b;
            border-radius: 3px;
          }
        }
      }
    }
    .title-img {
      position: absolute;
      left: 50%;
      top: 57px;
      transform: translateX(-50%);
      img {
        width: 259px;
      }
    }
    .change-bg {
      position: absolute;
      top: 60px;
      right: 0;
      height: 34px;
      font-size: 12px;
      background-color: rgba(0, 0, 0, 0.8);
      border: 1px solid #fff;
      border-radius: 4px;
      text-align: center;
      line-height: 34px;
      color: #fff;
      z-index: 10;
      padding: 0 10px;
      display: none;
    }
    .card-back {
      position: absolute;
      left: 50%;
      top: 128px;
      transform: translateX(-50%);
      &:hover {
        .switch-card-bg {
          display: block;
        }
      }
      .normarl-card-back,
      .fusion-cad-back {
        img {
          width: 240px;
        }
      }
      .switch-card-bg {
        position: absolute;
        left: 36px;
        top: 0;
      }
    }
    .card-list-wrapper {
      position: absolute;
      top: 468px;
      left: 15px;
      right: 15px;
      .card-list {
        overflow-x: auto;
        .card-item {
          flex-shrink: 0;
          margin-right: 15px;
        }
        .single-card {
          width: 72px;
          height: 96px;
          background-size: 100% 100%;
        }
        .card-name {
          height: 18px;
          font-size: 14px;
          color: #fff;
          text-align: center;
          .ipt {
            background: transparent;
            color: #fff;
            text-align: center;
            font-size: 12px;
            border: none;
            outline: none;
            width: 72px;
          }
        }
      }
    }
    .phone-btn-wrapper {
      position: absolute;
      top: 600px;
      left: 0;
      right: 0;
      .get-card,
      .do-task {
        border: none;
      }
      .get-card {
        width: 210px;
        height: 43px;
        line-height: 43px;
        background-size: 100% 100%;
        font-size: 18px;
        font-weight: bold;
        color: #f82c2c;
        text-align: center;
      }
      .do-task {
        width: 105px;
        height: 43px;
        background-size: 100% 100%;
        text-align: center;
        .title {
          font-size: 16px;
          color: #fff;
        }
        .tips {
          font-size: 12px;
          color: #ffc66e;
        }
      }
    }
  }
}
</style>
